import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient, { KlydoUpdatePayload } from "../../../api/klydo";

interface UseKlydoMutationOptions {
  onSuccess?: (data: unknown, variables: KlydoUpdatePayload) => void;
  onError?: (error: Error, variables: KlydoUpdatePayload) => void;
}

const useKlydoMutation = (
  klydoId: string,
  options?: UseKlydoMutationOptions,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["klydo", klydoId],
    mutationFn: (klydo: KlydoUpdatePayload) =>
      klydoApiClient.updateKlydo(klydoId, klydo),
    onSuccess: (data, variables) => {
      queryClient.refetchQueries({
        queryKey: ["klydo", klydoId],
      });

      options?.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      options?.onError?.(error, variables);
    },
  });
};

export default useKlydoMutation;
